import React from 'react';
import Header from './components/landing/Header';
import Hero from './components/landing/Hero';
import About from './components/landing/About';
import Accolades from './components/landing/Accolades';
import Services from './components/landing/Services';
import Testimonials from './components/landing/Testimonials';
import Contact from './components/landing/Contact';
import Footer from './components/landing/Footer';
// WhatsApp Chatbot - Hidden for now, will be re-enabled with WhatsApp Business API
// import WhatsAppChatbot from './components/landing/WhatsAppChatbot';
import { Toaster } from 'sonner';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* Hidden Google Translate Element */}
      <div id="google_translate_element" style={{ display: 'none' }}></div>
      
      <Toaster position="top-right" richColors />
      <Header />
      <main>
        <Hero />
        <About />
        <Accolades />
        <Services />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      {/* WhatsApp Chatbot - Will be enabled with WhatsApp Business API */}
      {/* <WhatsAppChatbot /> */}
    </div>
  );
}

export default App;
